module.exports = __webpack_public_path__ + "components/ServicesCategories/icons/ochr_srodowiska.svg?28273b41";


//////////////////
// WEBPACK FOOTER
// ./components/ServicesCategories/icons/ochr_srodowiska.svg
// module id = 1869
// module chunks = 0